import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { Button } from '@cld/button';
import { messages } from '../../i18n';

const IMAGE_URL = 'https://res.cloudinary.com/prod/image/upload/q_auto,f_auto/v1625729664/cookbook-standalone/mood-bad-black-24-dp_3x.png';

const Wrapper = styled.div`
  min-height: 530px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 96px;
  height: 96px;
  display: block;
`;

const Text = styled.div`
  ${typography.xl.regular}
  margin: ${globalTheme.spacing.lg} 0;
`;

export interface NotFoundRecipeProps {
  onBackToCookbookClick: () => void;
}

export const NotFoundRecipe: FC<React.PropsWithChildren<NotFoundRecipeProps>> = ({ onBackToCookbookClick }) => {
  return (
    <Wrapper>
      <Image src={IMAGE_URL} alt="recipe not found" />

      <Text>
        <FormattedMessage {...messages['pages.details.not-found-text']} />
      </Text>

      <Button variant="secondary" size="md" onClick={onBackToCookbookClick}>
        <FormattedMessage {...messages['pages.details.buttons.back']} />
      </Button>
    </Wrapper>
  );
};
